import { Theme } from "@mui/material/styles";

export default function Input(theme: Theme) {
    return {
        MuiInputBase: {
            styleOverrides: {
                root: {
                    "&.Mui-disabled": {
                        "& svg": { color: theme.palette.text.disabled },
                    },
                },
                input: {
                    "&::placeholder": {
                        opacity: 1,
                        color: theme.palette.text.disabled,
                    },
                },
                multiline: {
                    padding: "0 !important",
                },
            },
        },
        MuiInput: {
            styleOverrides: {
                underline: {
                    "&:before": {
                        borderBottomColor: theme.palette.grey[500_56],
                    },
                },
            },
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    backgroundColor: theme.palette.grey[500_12],
                    "&:hover": {
                        backgroundColor: theme.palette.grey[500_16],
                    },
                    "&.Mui-focused": {
                        backgroundColor: theme.palette.action.focus,
                    },
                    "&.Mui-disabled": {
                        backgroundColor: theme.palette.action.disabledBackground,
                    },
                },
                underline: {
                    "&:before": {
                        borderBottomColor: theme.palette.grey[500_56],
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    backgroundColor: theme.palette.background.textField,
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: theme.palette.grey[500_32],
                    },
                    "&.Mui-disabled": {
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: theme.palette.action.disabledBackground,
                        },
                    },
                },
                input: {
                    borderRadius: "inherit",
                    padding: theme.spacing(1.25, 1.75),
                },
                inputSizeSmall: {
                    borderRadius: "inherit",
                    padding: theme.spacing(1.0625, 1.75),
                },
                notchedOutline: {
                    top: 0,
                    "& > legend": {
                        display: "none",
                    },
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: theme.palette.text.inputLabel,
                    lineHeight: 1.5,
                    fontSize: theme.typography.pxToRem(14),
                    fontWeight: theme.typography.fontWeightMedium,
                    marginBottom: theme.spacing(0.375),
                    transform: "none",
                    position: "relative",
                    top: "auto",
                    left: "auto",
                },
            },
        },
    };
}
